import {ItemType} from './item'
import { SortRequest } from '../../../core/component/Search'

export enum ItemShowOptions {
  All = 'All',
  ArchivedOnly = 'ArchivedOnly',
  NoneArchived = 'NoneArchived',
}

export interface ItemFindRequest {
  id?: number
  sku?: string
  search?: string
  types?: ItemType[]
  vendorId?: number
  vendorIds?: number[]
  style?: string
  styleExactMatch?: boolean
  categoryId?: number[]
  subcategoryId?: number[]
  subcategory2Id?: number[]
  categoryTitle?: string
  subcategoryTitle?: string
  subcategory2Title?: string
  patternNumber?: string
  patternNumberExactMatch?: boolean
  showNoEffects?: boolean
  showOnWeb?: boolean
  archived?: boolean
  inStock?: boolean
  sort?: SortRequest[]
}

export interface ItemPageRequest {
  id?: number
  sku?: string
}